import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { SportsService } from 'src/app/services/sports.service';
import { EventMappingType, SpecialOfferType } from 'src/app/models/enums';
import { ISportRegionCompetitionSelection } from 'src/app/models/sportHierarchy/sportRegionCompetitionSelection.interface';
import { IBetTypeGroup } from 'src/app/models/betType/betTypeGroup.interface';
import { IBetTypeGroupingTemplateItem } from 'src/app/models/betType/betTypeGroupingTemplateItem.interface';
import { EventsService } from 'src/app/services/events.service';
import { UtilityService } from 'src/app/services/util/utility.service';

@Component({
  selector: 'app-events-bet-type-groups',
  templateUrl: './events-bet-type-groups.component.html',
  styleUrls: ['./events-bet-type-groups.component.less']
})
export class EventsBetTypeGroupsComponent implements OnInit, OnChanges, OnDestroy {

  betTypeGroupsLists: any;
  // selectedBetType: any;
  selectedBetTypeGroup: IBetTypeGroup;
  selectedBetTypeGrupId = -1;
  selectedBetTypeGroupingTemplateItem1: IBetTypeGroupingTemplateItem;
  selectedBetTypeGroupingTemplateItem2: IBetTypeGroupingTemplateItem;
  selectedBetTypeGroupingTemplateItem3: IBetTypeGroupingTemplateItem;
  specialOfferTypeEnum = SpecialOfferType;
  isMobileView: boolean;

  @Input()
  betTypeGroups: IBetTypeGroup[];

  @Input()
  selectionChanged: boolean;

  @Input()
  specialOfferType: SpecialOfferType;

  @Input()
  sportId: number;

  @Input()
  regionId: number;

  @Input()
  competitionId: number;
  // @Output()
  // betTypeGroupSelected: EventEmitter<{ betTypeGroup: IBetTypeGroup, betTypeGroupingTemplateItems: IBetTypeGroupingTemplateItem[] }> = new EventEmitter<{ betTypeGroup: null, betTypeGroupingTemplateItems: null }>();

  srcSelection: ISportRegionCompetitionSelection;
  constructor(private sportsService: SportsService, private utilityService: UtilityService) {
    this.srcSelection = this.sportsService.sportRegionCompetitionSelection;
    // this.srcSelection = {
    //   sport: this.sportsService.sportRegionCompetitionSelection.sport,
    //   region: this.sportsService.sportRegionCompetitionSelection.region,
    //   competition: this.sportsService.sportRegionCompetitionSelection.competition,
    // };
  }

  ngOnInit(){
    this.isMobileView = this.utilityService.mobileView;
  }

  ngOnChanges(changes: SimpleChanges): void {
    let selectionChanged = false;
    if (changes.selectionChanged && (changes.selectionChanged.previousValue !== changes.selectionChanged.currentValue || !changes.selectionChanged.previousValue)) {
      selectionChanged = true;
    }

    if (this.betTypeGroups.length > 0) {
      this.selectBetTypeGroup((this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId] && this.betTypeGroups.findIndex(g => g.id === this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroup.id) > -1) ? this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroup : this.betTypeGroups[0], selectionChanged);
    }else{
      this.selectedBetTypeGroupingTemplateItem1 = null;
      this.selectedBetTypeGroupingTemplateItem2 = null;
      this.selectedBetTypeGroupingTemplateItem3 = null;
    }
  }

  test(deviceValue) {
    // console.log(deviceValue);
  }

  selectBetTypeGroup(betTypeGroup: IBetTypeGroup, selectoionChanged?: boolean) {
    if (!betTypeGroup || (betTypeGroup.id === this.selectedBetTypeGrupId && !selectoionChanged)) { return; }
    this.selectedBetTypeGroupingTemplateItem1 = null;
    this.selectedBetTypeGroupingTemplateItem2 = null;
    this.selectedBetTypeGroupingTemplateItem3 = null;
    this.selectedBetTypeGrupId = betTypeGroup.id;
    this.selectedBetTypeGroup = betTypeGroup;

    if (this.selectedBetTypeGroup.betTypeGroupingTemplateItems.length > 0) {

      if (this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId] && this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroup.id === betTypeGroup.id) {
        this.selectedBetTypeGroupingTemplateItem1 = this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroupingTemplateItems[0];
        this.selectedBetTypeGroupingTemplateItem2 = this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroupingTemplateItems[1] ? this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroupingTemplateItems[1] : null;
        this.selectedBetTypeGroupingTemplateItem3 = this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroupingTemplateItems[2] ? this.sportsService.selectedBetTypeGroupAndTemplateItemsForSports[this.sportId].betTypeGroupingTemplateItems[2] : null;
      } else {
        this.selectedBetTypeGroupingTemplateItem1 = this.selectedBetTypeGroup.betTypeGroupingTemplateItems[0];
        if (!this.isMobileView) {
          this.selectedBetTypeGroupingTemplateItem2 = this.selectedBetTypeGroup.betTypeGroupingTemplateItems[1] ? this.selectedBetTypeGroup.betTypeGroupingTemplateItems[1] : null;
          this.selectedBetTypeGroupingTemplateItem3 = this.selectedBetTypeGroup.betTypeGroupingTemplateItems[2] ? this.selectedBetTypeGroup.betTypeGroupingTemplateItems[2] : null;
        }
      }

      // this.betTypeGroupSelected.emit({ betTypeGroup: this.selectedBetTypeGroup, betTypeGroupingTemplateItems: this.selectedBetTypeGroupingTemplateItemsToList() });
      this.sportsService.changeSelectedBetTypeGroupForGroup({
        betTypeGroup: this.selectedBetTypeGroup,
        betTypeGroupingTemplateItems: this.selectedBetTypeGroupingTemplateItemsToList(),
        sportId : this.sportId,
        regionId: this.regionId,
        competitionId: this.competitionId
      });
    }
  }

  selectBetTypeGroupById(id: string): void {
    const betTypeGroup = this.betTypeGroups.find(g => g.id === +id );
    this.selectBetTypeGroup(betTypeGroup);
  }

  // selectBetTypeGroupingTemplateItem(betTypeGroupingTemplateItem: IBetTypeGroupingTemplateItem) {
  //   if (betTypeGroupingTemplateItem.id === this.selectedBetTypeGroupingTemplateItem1?.id) {
  //     return;
  //   }


  //   this.selectedBetTypeGroupingTemplateItem3 = this.selectedBetTypeGroupingTemplateItem2;
  //   this.selectedBetTypeGroupingTemplateItem2 = this.selectedBetTypeGroupingTemplateItem1;
  //   this.selectedBetTypeGroupingTemplateItem1 = betTypeGroupingTemplateItem;

  //   if (this.selectedBetTypeGroupingTemplateItem1.id === this.selectedBetTypeGroupingTemplateItem2.id) {
  //     this.selectedBetTypeGroupingTemplateItem2 = this.selectedBetTypeGroup.betTypeGroupingTemplateItems.find(btgti => btgti.id !== this.selectedBetTypeGroupingTemplateItem1.id);
  //   }

  //   if (this.selectedBetTypeGroupingTemplateItem1.id === this.selectedBetTypeGroupingTemplateItem3.id) {
  //     this.selectedBetTypeGroupingTemplateItem3 = this.selectedBetTypeGroup.betTypeGroupingTemplateItems.find(btgti => btgti.id !== this.selectedBetTypeGroupingTemplateItem1.id && btgti.id !== this.selectedBetTypeGroupingTemplateItem2.id);
  //   }

  //   this.sportsService.changeSelectedBetTypeGroupForGroup({
  //     betTypeGroup: this.selectedBetTypeGroup,
  //     betTypeGroupingTemplateItems: this.selectedBetTypeGroupingTemplateItemsToList(),
  //     sportId: this.sportId,
  //     regionId: this.regionId,
  //     competitionId: this.competitionId
  //   });
  // }

  selectBetTypeGroupingTemplateItem(betTypeGroupingTemplateItem: IBetTypeGroupingTemplateItem) {
    if (!this.isMobileView) {
      if (betTypeGroupingTemplateItem.id === this.selectedBetTypeGroupingTemplateItem1.id
        || betTypeGroupingTemplateItem.id === this.selectedBetTypeGroupingTemplateItem2.id
        || betTypeGroupingTemplateItem.id === this.selectedBetTypeGroupingTemplateItem3.id) {
        return;
      }
    } else {
      if (betTypeGroupingTemplateItem.id === this.selectedBetTypeGroupingTemplateItem1.id) {
        return;
      }
    }

    if (!this.isMobileView) {
      this.selectedBetTypeGroupingTemplateItem3 = betTypeGroupingTemplateItem;
    } else {
      this.selectedBetTypeGroupingTemplateItem1 = betTypeGroupingTemplateItem;
    }

    this.sportsService.changeSelectedBetTypeGroupForGroup({
      betTypeGroup: this.selectedBetTypeGroup,
      betTypeGroupingTemplateItems: this.selectedBetTypeGroupingTemplateItemsToList(),
      sportId: this.sportId,
      regionId: this.regionId,
      competitionId: this.competitionId
    });
  }

  selectBetTypeGroupingTemplateItemById(id: string): void {
    const betTypeGroupingTemplateItem = this.selectedBetTypeGroup.betTypeGroupingTemplateItems.find(g => g.id === +id );
    this.selectBetTypeGroupingTemplateItem(betTypeGroupingTemplateItem);
  }

  private selectedBetTypeGroupingTemplateItemsToList(): IBetTypeGroupingTemplateItem[]{
    const templateItems: IBetTypeGroupingTemplateItem[] = [];
    if (this.selectedBetTypeGroupingTemplateItem1) {
      templateItems.push(this.selectedBetTypeGroupingTemplateItem1);
    }

    if (this.selectedBetTypeGroupingTemplateItem2) {
      templateItems.push(this.selectedBetTypeGroupingTemplateItem2);
    }

    if (this.selectedBetTypeGroupingTemplateItem3) {
      templateItems.push(this.selectedBetTypeGroupingTemplateItem3);
    }
    return templateItems;
  }

  ngOnDestroy(): void {
  }
}
